import React, { useEffect, useRef } from "react";
import "./CompareLoanComponent.css";
import RedRoundBtn from "../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faCalendarDay,
  faCalendarDays,
} from "@fortawesome/free-solid-svg-icons";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const CompareLoanComponent = ({
  date,
  setDate,
  EMITotal,
  interestTotal,
  loanValueTotal,
}) => {
  const navigate = useNavigate();
  const todayDate = new Date().toISOString().split("T")[0];
  const dateInputRef = useRef(null);
  useEffect(() => {
    if (!date) {
      setDate(new Date().toISOString().split("T")[0]);
    }
  }, [date, setDate]);
  return (
    <div className="CompareLoanComponent">
      <div className="compare_loan_div">
        <p className="text">Compare loan rates from top banks side-by-side</p>
        <div className="btn_holder">
          <RedRoundBtn
            btn_name="Apply for Loan"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>
      </div>

      <div className="schedule_emi_div">
        <div className="text_holder">
          <p className="text">Schedule showing EMI payments starting from</p>
        </div>

        <div className="date_input_div">
          <InputGroup size="sm">
            <Form.Control
              ref={dateInputRef}
              aria-label="Small"
              type="date"
            //   defaultValue={todayDate}
              aria-describedby="inputGroup-sizing-sm"
              value={date} // Bind value to state
              onChange={(e) => setDate(e.target.value)} // Update state on change
            />
            <InputGroup.Text id="inputGroup-sizing-sm">
              <FontAwesomeIcon
                icon={faCalendarDays}
                className="calnedar_icon"
                onClick={() => dateInputRef.current.showPicker()} // Open date picker on icon click
              />
            </InputGroup.Text>
          </InputGroup>
        </div>
      </div>
    </div>
  );
};

export default CompareLoanComponent;
